module.exports = new __parcel__URL__("issues-preview-dark.5cdc89fc.svg").toString();